import { computed } from 'vue';

export function useFlyoutsMenu() {
  const navHeader = useNavHeader();

  return { flyouts: computed(() => navHeader.getFlyoutsMenu) };
}
